import React, { useState, useEffect } from "react";
import { useGeneralContext } from "../General/Context";
import IconThreeDots from "../../layout/others/three-dots.svg";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "../styles/navbar.scss";
import { InterviewService } from "../../services/InterviewService";
import { toast } from "react-toastify";
import { useInterviewContext } from "./InterviewContext";
import ModalCreateContact from "./ModalCreateContact";
import { NewApplicationModal } from "./NewApplicationModal";
import { ChangeEmailModal } from "./ChangeEmailModal";
import { emailService } from "../../services/EmailService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AvailabilitiesListService } from "../../services/AvailabilitiesListService";
import AvailabilityListManager from "./AvailabilityList/AvailabilityListManager";
import { showWarning } from "../../services/ModalService";
import ModalInterviewHistory from "./InterviewOptions/ModalInterviewHistory";
import ModalDNASentSuccessfully from "./InterviewOptions/ModalDNASentSuccessfully";
import ExcludeInterview from "./HeaderThreeDots/ExcludeInterview";
import Recommended from "../Global/Recommended/Recommended";
import Arrow from "../../layout/navbar_icons/left_arrow.svg";
import "../../pages/styles/navbar.scss";
import TagOption from "../../components/Tags/TagOption";
import ModalSelectDocOnlineLanguage from "./ModalSelectDocOnlineLanguage";

const FINANCIAL_V2_ALLOWED_COMPANIES = ["AGAP2", "TeamIT", "KCS", "Adentis", "Bee", "Codewin", "AGAP2IND"];

export function HeaderThreeDotsDropDown({
  isInterviewActive,
  hasInterviewId,
  fromUrl,
  interview,
  setInterview,
  hideOnscreenCall,
  editMode
}) {
  const { userInformation } = useGeneralContext();
  const [shoModalSendDNA, setShowModalSendDNA] = useState(false);
  const [showModalSelectDocOnlineLanguage, setShowModalSelectDocOnlineLanguage] = useState(false);
  const { setAvailabilityListStatus } = useInterviewContext();
  const { t } = useTranslation();
  const [isOpenMOdalNewApplication, setIsOpenModalNewApplication] = useState(false);
  const [recommended, setRecommended] = useState({
    managerId: [],
    hrUsersId: [],
    otherManagerId: [],
    comment: ""
  });
  const [showModalInterviewHistory, setShowModalInterviewHistory] = useState(false);
  const [interviewHistory, setInterviewHistory] = useState([]);
  const [isOpenchangeEmail, setIsOpenChangeEmail] = useState(false);
  const [isOpenRecommendForm, setIsOpenRecommendForm] = useState(false);
  const [managers, setManagers] = useState([]);
  const [showModalCreateContact, setShowModalCreateContact] = useState(false);

  let history = useHistory();

  const [isOpenAvailability, setIsOpenAvailability] = useState(false);

  const openRecommendedForm = () => {
    setIsOpenRecommendForm(true);
  };

  const closeRecomendForm = () => {
    setIsOpenRecommendForm(false);
  };

  const closeForm = () => {
    closeRecomendForm();
    setRecommended({
      managerId: [],
      hrUsersId: [],
      otherManagerId: [],
      comment: ""
    });
  };

  function generateDocOnline() {
    window.open(
      `/interviews/DOCEdit/${interview.interviewId}/${interview.docOnlineLanguageId}`
    );
  }
  function openModalNewApplication() {
    setIsOpenModalNewApplication(true);
  }
  function closeNewApplicationModal(applicationDetails) {
    if (applicationDetails)
      setInterview({ ...interview, applicationDetails: applicationDetails });

    setIsOpenModalNewApplication(false);
  }
  
  function changeEmail(email) {
    emailService.changeEmail(email, interview.interviewId).then((data) => {
      if (data.sucess) {
        let personalInformation = { ...interview.personalInformation };
        personalInformation.emailAddress = email;
        setInterview({
          ...interview,
          personalInformation: personalInformation
        });
        setIsOpenChangeEmail(false);
        toast.success(t("Email changed successfully"));
      }
    }).catch((error) => {
      toast.error(t("An error occurred while changing the email"));
    });
  }

  const openFinancialCalculation = (fromUrl, isRise) => {
    if (!interview.isFinalized) {
      showWarning(
        t("Option unavailable because the interview is not finished")
      );
    } else {
      history.push(
        `/proposals/projectEstimation/${
          interview.interviewId
        }?returnUrl=interview/${fromUrl}/${
          interview.interviewId
        }?tab=documents${isRise ? `&isRise=true` : ""}`
      );
    }
  };
  const openModalInterviewHistory = () => {
    let history = [{}];
    (async () => {
      history = await InterviewService.getInterviewHistory(
        interview.interviewId
      );
      setInterviewHistory(history);
      setShowModalInterviewHistory(true);
    })();
  };
  
  function submitSendDocOnline(languageId) {
    InterviewService.sendDocOnline({
      interviewId: interview.interviewId,
      generatedLanguageId: languageId
    }).then((data) => {
      if (data === undefined) {
        setShowModalSendDNA(true);
      }
    });
  }
   
  function sendDocOnline() {
    if (
      !interview.personalInformation.fullName &&
      interview.personalInformation.emailAddress
    ) {
      toast.warning(
        `${t("Please fill in the name and email to send the Doc Online!")}`
      );
      return;
    }
 
    if (
      interview.hasPendingDocOnline === true ||
      interview.docOnlineStatus === "Expired"
    ) {
      showWarning(
        t(
          "A docOnline was already sent, do you wish to send another docOnline?"
        ),
        () => setShowModalSelectDocOnlineLanguage(true) 
      );
      return;
    }

    setShowModalSelectDocOnlineLanguage(true); 
  }

  return interview ? (
    <>
      <div className=" dropdown" style={{ marginTop: "17px" }}>
        <button
          type="button"
          className="action-button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img src={IconThreeDots} alt="threedots" title={t("Options")} />
        </button>{" "}
        <ul className="dropdown-menu">
          {interview.isFinalized && !interview.isHired && !hideOnscreenCall && (
            <>
              <li>
                <a className="dropdown-item" href="#!">
                  <img src={Arrow} alt="arrow" className="left-arrow" />
                  <div className="margin-label-language">{t("Tags")}</div>
                </a>
                <ul
                  className="submenu dropdown-menu submenu-left "
                  style={{ right: "100%", marginTop: "-30px" }}
                >
                  <TagOption
                    interviewTag={interview.tags}
                    setInterviewTag={(_tags) =>
                      setInterview({ ...interview, tags: _tags })
                    }
                    editMode={editMode}
                  />
                </ul>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  type="button"
                  onClick={() => {
                    setIsOpenAvailability(true);
                  }}
                >
                  {t("Availability")}
                </button>
              </li>{" "}
              <li>
                <hr className="dropdown-divider" />
              </li>
            </>
          )}

          {isInterviewActive &&
            userInformation.permissions.RecommendManager_Interview &&
            !hideOnscreenCall &&
            interview.isHired === false && (
              <li>
                <button
                  className="dropdown-item"
                  type="button"
                  onClick={openRecommendedForm}
                >
                  {t("Share to Team")}
                </button>
              </li>
            )}
          {isInterviewActive &&
            interview.isHired === false &&
            !hideOnscreenCall && (
              <li>
                <button
                  className="dropdown-item"
                  type="button"
                  onClick={() => setShowModalCreateContact(true)}
                >
                  {t("Create Contact")}
                </button>
              </li>
            )}
          {isInterviewActive &&
            userInformation.permissions.FinancialCalculation_Interview &&
            !hideOnscreenCall && (
              <>
                {!FINANCIAL_V2_ALLOWED_COMPANIES.includes(
                  userInformation.companyAbbreviation
                ) && (
                  <li>
                    <button
                      className="dropdown-item"
                      type="button"
                      disabled={hasInterviewId}
                      onClick={() => {
                        openFinancialCalculation(fromUrl);
                      }}
                    >
                      {t("Financial calculation")}
                    </button>
                  </li>
                )}
                {userInformation.permissions?.FinancialCalculation_Interview &&
                  !hideOnscreenCall &&
                  FINANCIAL_V2_ALLOWED_COMPANIES.includes(
                    userInformation.companyAbbreviation
                  ) && (
                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                        disabled={hasInterviewId}
                        onClick={() => {
                          openFinancialCalculation(fromUrl, true);
                        }}
                      >
                        {t("Financial calculation v2")}
                      </button>
                    </li>
                  )}
              </>
            )}
          {userInformation.permissions.History_Interview && !hideOnscreenCall && (
            <li>
              <button
                className="dropdown-item"
                type="button"
                disabled={hasInterviewId}
                onClick={() => {
                  openModalInterviewHistory();
                }}
              >
                {t("History")}
              </button>
            </li>
          )}
          {!interview.isHired && !hideOnscreenCall && (
            <>
              <li>
                <button
                  className="dropdown-item"
                  type="button"
                  onClick={openModalNewApplication}
                  disabled={hasInterviewId}
                >
                  {t("New Application")}
                </button>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
            </>
          )}
          {isInterviewActive &&
            userInformation.permissions.DOCOnline_Interview &&
            interview.personalInformation.interestType !== "Hired" && (
              <>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => {
                      sendDocOnline();
                    }}
                  >
                    {t("Send Doc Online")}
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => {
                      generateDocOnline();
                    }}
                  >
                    {t("Generate DOC Online")}
                  </button>
                </li>
              </>
            )}
          <li>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => {
                setIsOpenChangeEmail(true);
              }}
            >
              {" "}
              {t("Change Email")}
            </button>
          </li>
          {interview.createdBy === userInformation.id && (
            <>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <ExcludeInterview interviewId={interview.interviewId} />
              </li>
            </>
          )}
        </ul>
      </div>

      <Recommended
        interviewId={interview.interviewId}
        isOpenRecommendForm={isOpenRecommendForm}
        closeForm={closeForm}
        companyId={userInformation.companyId}
      />

      {showModalCreateContact && (
        <ModalCreateContact
          showModal={showModalCreateContact}
          setShowModal={setShowModalCreateContact}
          interviewId={interview.interviewId}
        />
      )}

      {isOpenMOdalNewApplication && (
        <NewApplicationModal
          close={closeNewApplicationModal}
          isOpen={isOpenMOdalNewApplication}
          managers={managers}
          interviewId={interview.interviewId}
        />
      )}
      {isOpenchangeEmail && (
        <ChangeEmailModal
          isOpen={isOpenchangeEmail}
          currentEmail={interview.personalInformation.emailAddress}
          setIsOpen={setIsOpenChangeEmail}
          submitChange={changeEmail}
        />
      )}

      <AvailabilityListManager
        interviewId={interview.interviewId}
        translator={t}
        InterviewSkills={interview.technologies
          .map((t) => t.description)
          .join(", ")}
        AvailabilitiesListService={AvailabilitiesListService}
        email={interview.personalInformation?.emailAddress}
        generatedDocOlineLanguageId={interview.docOnlineLanguageId}
        setAvailabilityStatus={setAvailabilityListStatus}
        isOpen={isOpenAvailability}
        setIsOpen={setIsOpenAvailability}
      />
      <ModalInterviewHistory
        isOpen={showModalInterviewHistory}
        setIsOpen={setShowModalInterviewHistory}
        interviewHistory={interviewHistory}
        interview={interview}
      />
      <ModalDNASentSuccessfully
        showModal={shoModalSendDNA}
        setShowModal={setShowModalSendDNA}
      />
      <ModalSelectDocOnlineLanguage
        isOpen={showModalSelectDocOnlineLanguage}
        setIsOpen={setShowModalSelectDocOnlineLanguage}
        onSubmit={submitSendDocOnline}
      />
    </>
  ) : (
    <></>
  );
}

export default HeaderThreeDotsDropDown;

HeaderThreeDotsDropDown.propTypes = {
  isInterviewActive: PropTypes.bool.isRequired,
  openRecomendedForm: PropTypes.func.isRequired,
  hasInterviewId: PropTypes.func.isRequired,
  openInterviewPage: PropTypes.func.isRequired,
  openModalInterviewHistory: PropTypes.func.isRequired,
  sendDocOnline: PropTypes.func.isRequired
};
